import { create } from "zustand";
import { getAddressType } from "../services/addressLookup";

interface AddressLookupStore {
	addressLookupModalOpen: Record<string, boolean>;
	selectedAddresses: Record<string, string>;
	suggestions: Record<string, AddressSuggestion[]>;
	formattedAddresses: Record<string, FormattedAddress | null>;
	setAddressLookupModalOpen: (type: string, open: boolean) => void;
	setSelectedAddress: (type: string, address: string) => void;
	setSuggestions: (type: string, suggestions: AddressSuggestion[]) => void;
	getFormattedAddress: (type: string, suggestionId: string) => Promise<void>;
}

export interface AddressSuggestion {
	Text: string;
	Type: "BuildingNumber" | "Address";
	Description?: string;
	UnitNumber?: string;
	Id: string;
}

export interface FormattedAddress {
	address1: string;
	address2: string;
	city: string;
	state: string;
	postalCode: string;
	country: string;
}

export const useAddressLookupStore = create<AddressLookupStore>((set) => ({
	addressLookupModalOpen: {},
	selectedAddresses: {},
	suggestions: {},
	formattedAddresses: {},

	setAddressLookupModalOpen: (type, open) =>
		set((state) => ({
			addressLookupModalOpen: { ...state.addressLookupModalOpen, [type]: open },
		})),
	setSelectedAddress: (type, address) =>
		set((state) => ({
			selectedAddresses: { ...state.selectedAddresses, [type]: address },
		})),
	setSuggestions: (type, suggestions) =>
		set((state) => ({
			suggestions: { ...state.suggestions, [type]: suggestions },
		})),
	getFormattedAddress: async (type, suggestionId) => {
		try {
			const addressResult = (await getAddressType(suggestionId)).Items;
			const addressObj = addressResult.find((item) => item.Language === "ENG");
			if (addressObj) {
				const fullAddress = `${addressObj.Line1}, ${addressObj.Line2 ? `${addressObj.Line2}, ` : ""}${addressObj.City}, ${addressObj.Province}, ${addressObj.PostalCode}`;

				set((state) => ({
					formattedAddresses: {
						...state.formattedAddresses,
						[type]: {
							address1: addressObj.Line1,
							address2: addressObj.Line2,
							city: addressObj.City,
							state: addressObj.Province,
							postalCode: addressObj.PostalCode,
							country: addressObj.CountryIso2,
						},
					},
					selectedAddresses: {
						...state.selectedAddresses,
						[type]: fullAddress,
					},
				}));
			}
		} catch (error) {
			console.error("Failed to fetch formatted address", error);
		}
	},
}));
